/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Currentpage_Currentproduct2Inputs */

const he_extension_popup_currentpage_currentproduct2 = /** @type {(inputs: Extension_Popup_Currentpage_Currentproduct2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצר נוכחי`)
};

const en_extension_popup_currentpage_currentproduct2 = /** @type {(inputs: Extension_Popup_Currentpage_Currentproduct2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current product`)
};

/**
* | output |
* | --- |
* | "Current product" |
*
* @param {Extension_Popup_Currentpage_Currentproduct2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_currentpage_currentproduct2 = /** @type {((inputs?: Extension_Popup_Currentpage_Currentproduct2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Currentpage_Currentproduct2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_currentpage_currentproduct2(inputs)
	return en_extension_popup_currentpage_currentproduct2(inputs)
});
export { extension_popup_currentpage_currentproduct2 as "extension_popup_currentPage_currentProduct" }